import React from 'react';
import PropTypes from 'prop-types';

import View from './TeamTypeSelector.view';

const TeamTypeSelector = ({ itemName, allItems, selected, updateSelected, isStartWith, refining, setRefining }) => {

	const onRefineChange = () => setRefining(!refining);

	const handleChange = event => {
		const isChecked = event.target.checked;
		const name = event.target.name;
		const updatedSet = new Set(selected);
		if (isChecked) {
			updatedSet.add(name);
		} else {
			updatedSet.delete(name);
		}
		updateSelected(updatedSet);
	};

	const handleClearAll = () => {
		const updatedSet = new Set([]);
		updateSelected(updatedSet);
	};

	const handleSelectAll = () => {
		const updatedSet = new Set(allItems);
		updateSelected(updatedSet);
	};

	return (
		<View
			isStartWith={isStartWith}
			itemName={itemName}
			allItems={allItems}
			refining={refining}
			onRefineChange={onRefineChange}
			selected={selected}
			handleChange={handleChange}
			handleClearAll={handleClearAll}
			handleSelectAll={handleSelectAll}
		/>
	);
};

TeamTypeSelector.propTypes = {
	itemName: PropTypes.string.isRequired,
	selected: PropTypes.object.isRequired,
	allItems: PropTypes.arrayOf(PropTypes.string).isRequired,
	updateSelected: PropTypes.func.isRequired,
	isStartWith: PropTypes.bool.isRequired,
	refining: PropTypes.bool.isRequired,
	setRefining: PropTypes.func.isRequired
};

export default TeamTypeSelector;
